import styled from 'styled-components';
import { white } from '../../../components/loggedout/shared-styles/Colors';
import { device } from '../../../utils/responsive_utilities';

export const SplashLogo = styled.div`
  background: ${white};
  text-align : center;
  padding: 0.8rem;
  & > a > img {
      width: 24.7rem;
      height: 3.2rem;
  }

  @media ${device.Desktop}, ${device.TabletLandscape}, ${device.Tablet}, ${device.PhoneLandscape}{
    & > a > img {
      width: 37rem;
      height: 4.8rem;
    }
  }
`

export const ContentWrapper = styled.div`
  position: fixed;
  z-index: 5;
  width: 100%;
  height: 3.2rem;
  @media ${device.Desktop}, ${device.TabletLandscape}, ${device.Tablet}, ${device.PhoneLandscape}{
    height: 4.8rem;
  }
`